(() => {
  // The theme server-renders the product's structured data (#CharterhouseProductSchema).
  // Apps such as Schema & Breadcrumbs and Reviews.io add their own Product markup, so this keeps
  // the theme's copy as the only Product on the page and leaves their other markup (e.g. breadcrumbs) alone.
  const own = document.getElementById('CharterhouseProductSchema');
  if (!own) return;
  const types = node => [].concat(node?.['@type'] || []);
  const isProduct = node => types(node).some(type => ['Product', 'ProductGroup'].includes(type));
  const parse = script => { try { return JSON.parse(script.textContent); } catch { return null; } };
  const encode = data => JSON.stringify(data).replace(/</g, '\\u003c');

  function withoutProducts(data) {
    if (Array.isArray(data)) {
      const kept = data.filter(node => !isProduct(node));
      return kept.length === data.length ? data : kept;
    }
    if (data && Array.isArray(data['@graph'])) {
      const kept = data['@graph'].filter(node => !isProduct(node));
      return kept.length === data['@graph'].length ? data : { ...data, '@graph': kept };
    }
    return isProduct(data) ? null : data;
  }

  function consolidate() {
    document.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
      if (script === own) return;
      const data = parse(script);
      if (!data) return;
      const kept = withoutProducts(data);
      if (kept === data) return;
      const empty = !kept || (Array.isArray(kept) ? !kept.length : Array.isArray(kept['@graph']) && !kept['@graph'].length);
      if (empty) script.type = 'application/json';
      else script.textContent = encode(kept);
    });
    const reviewSnippets = document.getElementById('reviewsWidgetProductSnippets');
    if (reviewSnippets && reviewSnippets.type !== 'application/json') reviewSnippets.type = 'application/json';
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; consolidate(); });
  }
  const relevant = node => node?.nodeType === 1 && (node.matches?.('script[type="application/ld+json"], #reviewsWidgetProductSnippets') || node.querySelector?.('script[type="application/ld+json"], #reviewsWidgetProductSnippets'));
  new MutationObserver(records => {
    if (records.some(record => record.target.nodeName === 'SCRIPT' || record.target.parentElement?.nodeName === 'SCRIPT' || Array.from(record.addedNodes).some(relevant))) schedule();
  }).observe(document.documentElement, { subtree: true, childList: true, characterData: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', consolidate, { once: true });
  else consolidate();
})();
